// root '../../../';

// dependencies
import { Child } from 'pym.js';
import Zion from './utils/Zion';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)


// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

const d3 = require('d3');

const mapboxgl = require('mapbox-gl');
const MapboxGeocoder = require('@mapbox/mapbox-gl-geocoder');

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJja2V1M3Vyd3kwMDZrMnF0Njdhb3ZhZDk5In0.OURIYzTcS6ZzoWjXJzfANg';

const isMobile = window.innerWidth < 500;

const startLocation = ['-98.5', '39.8'];
const startZoom = isMobile ? 2.5 : 3.5;

const accumulationMap = new mapboxgl.Map({
  container: 'snow-accumulation-map',
  style: 'mapbox://styles/cnndigital/cllwui6vg00fz01qu0xl0cbu2',
  center: [startLocation[0], startLocation[1]],
  zoom: startZoom,
  minZoom: 3,
  maxZoom: 6,
  bearing: 0,
  scrollZoom: false,
  dragRotate: false,
  touchPitch: false,
  interactive: true,
  projection: 'albers',

});
accumulationMap.addControl(new mapboxgl.NavigationControl({
  showCompass: false,
}), 'top-right');
accumulationMap.addControl(new MapboxGeocoder({
  accessToken: mapboxgl.accessToken,
  mapboxgl,
  marker: false,
  flyTo: {
    curve: 1,
  },
}), 'bottom-left');
// accumulationMap.addControl(new mapboxgl.GeolocateControl({
//     positionOptions: {
//         enableHighAccuracy: false
//     },
//     trackUserLocation: false,
//     showUserHeading: false,
//     showUserLocation: false
// }), 'bottom-left');

accumulationMap.on('load', () => {
  const firstLayer = accumulationMap.getStyle().layers[7];

  accumulationMap.addSource('season', {
    type: 'raster',
    url: 'mapbox://cnndigital.wxsnowaccumseason26',
  });
  accumulationMap.addSource('average', {
    type: 'raster',
    url: 'mapbox://cnndigital.wxsnowaccumaverage26',
  });

  accumulationMap.addSource('change', {
    type: 'raster',
    url: 'mapbox://cnndigital.wxsnowaccumchange26',
  });

  accumulationMap.addLayer({
    id: 'season',
    type: 'raster',
    source: 'season',
    layout: { visibility: 'visible' },
    paint: {
      'raster-fade-duration': 0,
      'raster-opacity': 1,
    },
  },
  firstLayer.id);

  accumulationMap.addLayer({
    id: 'average',
    type: 'raster',
    source: 'average',
    layout: { visibility: 'none' },
    paint: {
      'raster-fade-duration': 0,
      'raster-opacity': 1,
    },
  },
  firstLayer.id);

  accumulationMap.addLayer({
    id: 'change',
    type: 'raster',
    source: 'change',
    layout: { visibility: 'none' },
    paint: {
      'raster-fade-duration': 0,
      'raster-opacity': 1,
    },
  },
  firstLayer.id);
  pymChild.sendHeight();
});
const accumulationButtons = document.querySelectorAll('.accumulation.button');
const accumulationLegends = document.querySelectorAll('.accumulation.map-legend-wrapper');

const updateAccumulation = (event) => {
  const t = event.target.dataset.layer;
  for (const layer of ['season', 'average', 'change']) {
    accumulationMap.setLayoutProperty(layer, 'visibility', 'none');
  }
  for (const b of accumulationButtons) {
    b.classList.remove('active');
  }
  for (const legend of accumulationLegends) {
    if (legend.classList.contains(t)) {
      legend.classList.add('visible');
    } else {
      legend.classList.remove('visible');
    }
  }
  accumulationMap.setLayoutProperty(t, 'visibility', 'visible');
  event.target.classList.add('active');
};

for (const button of accumulationButtons) {
  button.addEventListener('click', updateAccumulation);
}


d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
});

d3.json('https://ix.cnn.io/data/wx-snow-accum/accumulation-date.json').then((data) => {
  const updateTime = d3.timeParse('%Y-%m-%d %H:%M:%SZ')(`${data.timestamp}`);

  d3.select('#accumulation-map-timestamp')
    .text(`Accumulation as of ${d3.timeFormat('%-I:%M %p on %b %-d, %Y')(updateTime)}`);
});
